/**
 * @module ConstructorIO/product
 */

/**
 *  Class wrapping the Constructor.io response product data.
 */
export default class ConstructorIOProduct {
    #product = null;

    #country = null;

    /**
     * @param {Object} product - product from Constructor.io response
     */
    constructor(product) {
        this.#product = product.data;
        this.#product.value = product.value;
        this.#product.variationsMap = product.variations_map;
        this.#country = window.CURRENT_COUNTRY;
    }

    /**
     * @param {string} attributeID - attribute to get. Supports localization
     * @returns {any} attribute
     */
    get(attributeID) {
        let attribute = this.#product[`${attributeID}_${this.#country}`];
        if (!attribute) {
            attribute = this.#product[attributeID];
        }

        if (!attribute || attribute === '') {
            return null;
        }
        return attribute;
    }
}
